var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import { List as AntList } from 'antd';
export function LoadMore(_a) {
    var children = _a.children, onClick = _a.onClick;
    return (React.createElement("div", { style: {
            textAlign: 'center',
            fontSize: 14,
            padding: 10,
            cursor: 'pointer',
            color: '#62656d',
        }, onClick: onClick }, children));
}
export default function List(_a) {
    var fetchData = _a.fetchData, dataSource = _a.dataSource, getFetchParams = _a.getFetchParams, rest = __rest(_a, ["fetchData", "dataSource", "getFetchParams"]);
    var _b = React.useState(1), pageNo = _b[0], setPageNo = _b[1];
    var _c = React.useState(10), pageSize = _c[0], setPageSize = _c[1];
    var _d = React.useState(null), error = _d[0], setError = _d[1];
    var _e = React.useState([]), result = _e[0], setResult = _e[1];
    var _f = React.useState(false), loading = _f[0], setLoading = _f[1];
    React.useEffect(function () {
        if (!fetchData) {
            return;
        }
        var params = {
            pageNo: pageNo,
            pageSize: pageSize,
        };
        if (getFetchParams) {
            params = __assign(__assign({}, params), getFetchParams());
        }
        setLoading(true);
        fetchData(params)
            .then(function (data) {
            setResult(__spreadArrays(result, data));
            setPageNo(pageNo + 1);
        })
            .finally(function () {
            setLoading(false);
        })
            .catch(function (error) {
            setError(error);
        });
    }, [fetchData, getFetchParams]);
    return React.createElement(AntList, __assign({}, rest, { loading: loading, dataSource: dataSource || result }));
}
//# sourceMappingURL=index.js.map